import MultiTierCheckoutProvider from './context';
import MultiTierCheckoutModal from './MultiTierCheckoutModal';
import { MultiTierCheckoutProps } from './types';

const MultiTierCheckout = ({
  onClose,
  event,
  unlockedTier,
  defaultDiscountCode,
  defaultPromoterCode,
  onSuccess,
  onViewEventPostCheckout,
  metaPixelRef
}: MultiTierCheckoutProps) => (
  <MultiTierCheckoutProvider
    onClose={onClose}
    event={event}
    unlockedTier={unlockedTier}
    defaultDiscountCode={defaultDiscountCode}
    defaultPromoterCode={defaultPromoterCode}
    onSuccess={onSuccess}
    onViewEventPostCheckout={onViewEventPostCheckout}
    metaPixelRef={metaPixelRef}
  >
    <MultiTierCheckoutModal />
  </MultiTierCheckoutProvider>
);

export default MultiTierCheckout;
